import { soundToPlay } from "../sounds/sound";
import Character from "./Character";

export class Warrior extends Character {

    firstSkill(enemiesArr: Character[], enemiesIndex: number) {
        this.decSkillsCooldown()
        this.setSkillCooldown(1, 2)
        const atk = this.getAttack() + 3
        if (atk >= enemiesArr[enemiesIndex].getArmor()) {
            const dmg = (this.getDamage() + this.calcMod(this.getStr()))
            enemiesArr[enemiesIndex].setHp(enemiesArr[enemiesIndex].getHp() - dmg)
            soundToPlay("damageDeal")
        }
    }

    secondSkill(enemiesArr: Character[], enemiesIndex: number): void {
        this.decSkillsCooldown()
        this.setSkillCooldown(2, 3)
        const atk = this.getAttack() + 5
        if (atk >= enemiesArr[enemiesIndex].getArmor()) {
            const dmg = 2 * (this.getDamage() + this.calcMod(this.getStr()))
            enemiesArr[enemiesIndex].setHp(enemiesArr[enemiesIndex].getHp() - dmg)
            soundToPlay("damageDeal")
        }
    }

    thirdSkill(enemiesArr: Character[]): void {
        this.decSkillsCooldown()
        this.setSkillCooldown(3, 4)
        const dmg = 3 * (this.getDamage() + this.calcMod(this.getStr()))
        const atk = this.getAttack()
        enemiesArr.forEach(element => {
            if (atk >= element.getArmor()) {
                element.setHp(element.getHp() - dmg)
            }
        })
        soundToPlay("damageDeal")
    }

}